import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

export const Container = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: .8rem;
    padding: .4rem 1rem .4rem 1rem;
`
export const CustomButton = styled(ButtonMui)`
    width: 100%;    
    height: 2.8rem !important;
    margin: 0 !important;
`
export const ContainerInput = styled.div`
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    height: 3.2rem;
`

export const ContainerActions = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const ContainerButton = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1.4rem;
    width: 100%;
`
